/* update entity in array */
export * from './update-entity-in-array.function';
